//中山大学水表页面
export default [
    {
        // 角色管理
        path: '/roleManage',
        name: 'roleManage',
        component: () => import('@/page/zhongshanPage/roleManage.vue')
    },
    {
       // 账户参数设置
        path: '/accountSettings',
        name: 'accountSettings',
        component: () => import('@/page/zhongshanPage/accountSettings.vue')
    },
    {
        // 初始参数设置
        path: '/initialSettings',
        name: 'initialSettings',
        component: () => import('@/page/zhongshanPage/initialSettings.vue')
        },
    {
        // 区域关联
        path: '/userList',
        name: 'userList',
        component: () => import('@/page/zhongshanPage/userList.vue')
    },
    {
        // IC卡管理
        path: '/iCcard',
        name: 'iCcard',
        component: () => import('@/page/zhongshanPage/iCcard.vue')
    },
    {
        // 操作记录
        path: '/records',
        name: 'records',
        component: () => import('@/page/zhongshanPage/records.vue')
    },
    {
        // 区域配置
        path: '/areaDispose',
        name: 'areaDispose',
        component: () => import('@/page/zhongshanPage/areaDispose.vue')
    },
    {
        // 档案管理
        path: '/filesManage',
        name: 'filesManage',
        component: () => import('@/page/zhongshanPage/filesManage.vue')
    },
    {
        // 远程控制
        path: '/filesControl',
        name: 'filesControl',
        component: () => import('@/page/zhongshanPage/filesControl.vue')
    },
    {
        // 水表操控
        path: '/filesHandling',
        name: 'filesHandling',
        component: () => import('@/page/zhongshanPage/filesHandling.vue')
    },
    {
        // 水表当前状态
        path: '/filesState',
        name: 'filesState',
        component: () => import('@/page/zhongshanPage/filesState.vue')
    },
    {
        // 用量记录
        path: '/filesDosage',
        name: 'filesDosage',
        component: () => import('@/page/zhongshanPage/filesDosage.vue')
    },
    {
        // 设备操作记录
        path: '/filesOperate',
        name: 'filesOperate',
        component: () => import('@/page/zhongshanPage/filesOperate.vue')
    },
 ]
